export type * from './types'; 
export type * from './interfaces'; 
export * from './constants';
export * from './functions';
export * from './hooks';
export * from './configs/GLOBAL_ERROR_CONFIG';
export { ResourceConfigContext } from './contexts/ResourceConfigContext';
export { ResourceConfigProvider } from './components/ResourceConfigProvider';
export { ClientResourceProvider } from './components/ClientResourceProvider';
export { ConfiguredComponent } from './functions/ConfiguredComponent';

// Note: Server-side AsyncLocalStorage functions are NOT exported from main index
// to prevent browser bundling of Node.js 'async_hooks' module.
// Use the factory function '@shared/config/src/server/getRequestContextManager' for cross-platform compatibility. 